import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

export const createNewQuestion = createAsyncThunk(
  "createNewQuestion",
  async (params, { rejectWithValue }) => {
    try {
      const token = params?.token;
      const surveyId = params?.surveyId;
      const sectionId = params?.sectionId;
      const data = params?.data;
      // const questionId = params?.questionId;
      const url =
        process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_PREFIX_URL +
        surveyId +
        "/section/" +
        `${sectionId}` +
        "/question/new/";
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, data, { headers });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const createNewQuestionSlice = createSlice({
  name: "createNewQuestions",
  initialState,
  reducers: {
    clearData(state) {
      state.data = [];
      state.error = "";
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNewQuestion.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(createNewQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = "";
      })
      .addCase(createNewQuestion.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.payload || "An error occurred";
      });
  },
});

export const { clearData, setLoading } = createNewQuestionSlice.actions;
export default createNewQuestionSlice.reducer;
